import {
  Action,
  Block,
  PageList,
  PageListEntry,
  PageSet,
} from "src/pageDefinitions/types";
import {
  getPageAtLocation,
  getPageLocation,
  PageLocation,
} from "src/pageDefinitions/pageSets";
import invariant from "tiny-invariant";
import { CoreReduxState, CoreReduxStore } from "src/utils/redux/store";
import { conditionsPass } from "src/pageDefinitions/conditions";
import { SurveyAnswersState } from "@utils/redux/slices/surveyAnswers";
import { saveSurveyAnswers } from "src/utils/redux/slices/userData";

/**
 * Finds all survey-related pages that are defined within page set at given point.
 */

export function getPageSetSurvey(
  pageSet: PageSet,
  page: PageListEntry,
  state?: CoreReduxState
): {
  name: string;
  surveyNameSpace: string;
  loggedInHeader: boolean;
  blockLocation: PageLocation;
  pages?: PageList;
  props: Block["props"];
  onAnswered?: ReadonlyArray<Action>;
} {
  const location = pageSet && page && getPageLocation(pageSet, page);
  if (!location) {
    return {
      name: undefined,
      blockLocation: undefined,
      surveyNameSpace: "surveyAnswers",
      loggedInHeader: false,
      props: {},
    };
  }

  const blockLocation = location.slice(0, 1);
  const block = getPageAtLocation(pageSet, blockLocation);
  invariant(
    "name" in block,
    `No survey block found wrapping location ${location}`
  );
  invariant(block.name, `Survey block as location ${location} has no name`);

  // Include pages if a state is passed to eval against.
  let pages;
  if (state) {
    pages = block.block.filter((pageToFilter) =>
      conditionsPass(pageToFilter.conditions, state)
    );
  }

  return {
    name: block.name,
    surveyNameSpace: block.surveyNameSpace || "surveyAnswers",
    loggedInHeader: block.loggedInHeader,
    blockLocation: location.slice(0, -1),
    pages,
    props: block.props || {},
    onAnswered: block.onAnswered,
  };
}

export async function saveSurveyAnswersInUserData(
  store: CoreReduxStore,
  surveyNameSpace: string,
  surveyAnswers: SurveyAnswersState,
  dateKey: string
) {
  // saveSurveyAnswers stores in userData slice. This check ensures that the JSON config
  // will properly load that data in the future/on refresh.
  invariant(
    surveyNameSpace.startsWith("userData."),
    "surveyNameSpace must start with userData for this action."
  );

  await store.dispatch(
    saveSurveyAnswers(surveyAnswers, {
      surveyNameSpace: surveyNameSpace.replace("userData.", ""),
      dateKey,
    })
  );
}
